import { BusinessRules } from './BusinessRules';
import businessRules from './rules';

export type Rule = keyof BusinessRules
export type BusinessRulesCollection = Record<string, BusinessRules>

const businessRulesCollection = ((): BusinessRulesCollection => {
  const existingRules: BusinessRulesCollection = {};

  (Object.keys(businessRules) as Array<keyof typeof businessRules>)
    .forEach((credor) => {
      existingRules[credor] = {
        ...businessRules.standard,
        ...businessRules[credor],
      };
    });

  const rulesCollectionProxy: ProxyHandler<BusinessRulesCollection> = {
    set(): boolean {
      return false;
    },
    get(rulesCollection: Partial<BusinessRulesCollection>, credor: string | symbol): BusinessRules {
      if (Reflect.has(rulesCollection, credor)) {
        return Reflect.get(rulesCollection, credor);
      }

      return businessRules.standard;
    },
  };

  return new Proxy(existingRules, rulesCollectionProxy);
})();

export default businessRulesCollection;
